import React from 'react';
import clsx from 'clsx';
import Slider from "react-slick";

import { VideoBackground } from '../../components/VideoBackground';
import { HomeHero } from '../../components/HomeHero';
import Stats from '../../components/Stats';
import { ApplySection } from '../../components/ApplySection';
import Agenda from '../../components/Agenda';
import Arrow from '../../components/Arrow';

import LogoSliders1 from '../../assets/images/home/Logo-Sliders-1.png';
import LogoSliders2 from '../../assets/images/home/Logo-Sliders-2.png';
import LogoSliders3 from '../../assets/images/home/Logo-Sliders-3.png';
import LogoSliders4 from '../../assets/images/home/Logo-Sliders-4.png';
import LogoSliders5 from '../../assets/images/home/Logo-Sliders-5.png';

import iPhoneImg from '../../assets/images/iphone_chat.png';
import EmdSeronoLogo from '../../assets/images/emd-serono.svg';
import TimeWarnerLogo from '../../assets/images/time-warner.svg';
import AmericanExpressLogo from '../../assets/images/american-express.svg';
import BjsLogo from '../../assets/images/bjs.svg';

import aibleLogo from '../../assets/images/home/sponsor-logos/aible.png';
import deloitteLogo from '../../assets/images/home/sponsor-logos/deloitte.png';
import techolutionLogo from '../../assets/images/home/sponsor-logos/techolution.png';
import dataIkuLogo from '../../assets/images/home/sponsor-logos/data-iku.png';
import dotDataLogo from '../../assets/images/home/sponsor-logos/dotdata.png';
import braveLogo from '../../assets/images/home/sponsor-logos/brave.png';
import clarivateLogo from '../../assets/images/home/sponsor-logos/clarivate.png';
import bobidiLogo from '../../assets/images/home/sponsor-logos/bobidi.png';
import awsLogo from '../../assets/images/home/sponsor-logos/aws.png';
import capitalOneLogo from '../../assets/images/home/sponsor-logos/capital.png';
import ibmLogo from '../../assets/images/home/sponsor-logos/ibm.png';
import koreLogo from '../../assets/images/home/sponsor-logos/kore.png';
import h2oLogo from '../../assets/images/home/sponsor-logos/h2o.png';
import dvcLogo from '../../assets/images/home/sponsor-logos/dvc.png';
import autoNationLogo from '../../assets/images/home/sponsor-logos/autonation.png';

import './home.css';
import Button from '../../components/Button';
import HomeVideo from '../../assets/videos/homepage.mp4';
import RetconVideo from '../../assets/videos/retcon.mp4';

import Speakers from '../../components/Speakers';

const logos = [
  LogoSliders1,
  LogoSliders2,
  LogoSliders3,
  LogoSliders4,
  LogoSliders5,
];

const attendingLogos = [
  EmdSeronoLogo,
  TimeWarnerLogo,
  BjsLogo,
  AmericanExpressLogo,
];

const passItems = [
  {
    title: 'Standard<br />Pass',
    summary: 'For small teams or individual users attending',
    price: 995,
    discounted: 2495,
    description: 'Skip the application process & register now during “Early Registration” Pricing for a 60% discount.',
    contents: [
      'In-person access to all conference features including access to…',
      'All sessions & session recordings post-event',
      'Private networking app & networking events',
      'Breakfast, lunch & daily happy hours & happy hours',
      'Exhibit hall',
    ],
    buttonTitle: 'Apply now',
  },
  {
    title: 'Complimentary<br />Pass',
    summary: 'For small teams or individual users attending',
    price: 0,
    discounted: 2495,
    description: 'Complete the brief 1-minute application below. This pass type – for qualified attendees only – is highly limited and 100% free. You may qualify if you meet all 3 criteria below…',
    contents: [
      'Your company is not a vendor and has no sales interest in end-users of AI-related products or services',
      'You work at a non-vendor organization with 250+ employees',
      'You hold a senior-level position and/or technical role',
      'This pass type includes all benefits of the “Standard Pass”',
    ],
    buttonTitle: 'Apply now',
  },
  {
    title: 'AI Startup<br />Pass',
    summary: 'For small teams or individual users attending',
    price: 695,
    discounted: 1595,
    description: 'Complete the brief 1-minute application below. You may qualify if you meet all 3 criteria below…',
    contents: [
      'Have been in operation less than 3 years',
      'Have raised less than $3M',
      'Use AI as a core product feature',
    ],
    buttonTitle: 'Apply now',
  },
  {
    title: 'Government<br />Pass',
    summary: 'For small teams or individual users attending',
    price: 295,
    discounted: 2195,
    description: 'Complete the brief 1-minute application below. You may qualify if you meet all 3 criteria below…',
    contents: [
      'Have been in operation less than 3 years',
      'Have raised less than $5M',
      'Use AI as a core product feature',
      'This pass type includes all benefits of the “Standard Pass”',
    ],
    buttonTitle: 'Apply now',
  },
  {
    title: 'Media<br />Pass',
    summary: 'For small teams or individual users attending',
    price: 295,
    discounted: 995,
    description: 'Complete the brief 1-minute application below. This pass type – for qualified attendees only – is highly limited and 100% free. You may qualify if you meet all 3 criteria below…',
    contents: [
      'Must be an active journalist, influencer, or member of the media covering AI or data-related topics',
      'Must be approved by our team',
      'For Influencers Only: Must have a well-established following',
      'This pass type includes all benefits of the “Standard Pass”',
    ],
    buttonTitle: 'Apply now',
  },
]
const sponsorItems = [
  {
    name: 'AutoNation',
    logo: aibleLogo,
  },
  {
    name: 'AutoNation',
    logo: deloitteLogo,
  },
  {
    name: 'AutoNation',
    logo: techolutionLogo,
  },
  {
    name: 'AutoNation',
    logo: dataIkuLogo,
  },
  {
    name: 'AutoNation',
    logo: dotDataLogo,
  },
  {
    name: 'AutoNation',
    logo: braveLogo,
  },
  {
    name: 'AutoNation',
    logo: clarivateLogo,
  },
  {
    name: 'AutoNation',
    logo: bobidiLogo,
  },
  {
    name: 'AutoNation',
    logo: awsLogo,
  },
  {
    name: 'AutoNation',
    logo: capitalOneLogo,
  },
  {
    name: 'AutoNation',
    logo: ibmLogo,
  },
  {
    name: 'AutoNation',
    logo: koreLogo,
  },
  {
    name: 'AutoNation',
    logo: h2oLogo,
  },
  {
    name: 'AutoNation',
    logo: dvcLogo,
  },
  {
    name: 'AutoNation',
    logo: autoNationLogo,
  },
];

const testimonials = [
  {
    testimonial: 'It was a great conference, well worth it. I did some phenomenal networking. Really awesome stuff. I learned a lot.',
    position: 'SME',
    company: 'PureStorage',
  },
  {
    testimonial: 'It was the great audience, that exceeded all my expectations. It’s the most friendly environment in a conference that I have ever seen.',
    position: 'Cyber Security & Big Data Software Engineering',
    company: 'MIT STARTUP EXCHANGE',
  },
  {
    testimonial: 'It was a great event, very well organized!',
    position: 'Head of Enterprise Data Management',
    company: 'Sears',
  },
  {
    testimonial: 'It was invigorating to see the commitment to the technology and to gain insights from industry experts across the healthcare spectrum.',
    position: 'Senior Director of AI',
    company: 'Machine Learning, IQVIA',
  },
  {
    testimonial: 'We found the Ai4 event to be professionally organized, well attended and with abundance of high-quality market leaders and speakers.',
    position: 'CEO',
    company: 'Lucena Research',
  },
  {
    testimonial: 'I massively enjoyed the conference. The Ai4 Team runs an incredibly well organized show.',
    position: 'Soumyadeep B., NPI Analytics Leader',
    company: 'Honeywell',
  },
  {
    testimonial: 'The speakers were amazing. They covered a wide range of topics that will certainly help push our AI initiatives forward.',
    position: 'Assortment & Space Analyst',
    company: 'BJ’s Wholesale',
  },
  {
    testimonial: 'I had a fantastic time at the conference. I had a genuinely great time and met a lot of interesting people.',
    position: 'Global Head of Quality Management & Product Governance',
    company: 'Credit Suisse',
  },
  {
    testimonial: 'The individual presentations and moderated panels had a great combination of thoughtful commentary and technical details, satisfying a diverse audience of technologists and business leaders.',
    position: 'Founder & CEO',
    company: 'RCM Brain',
  },
  {
    testimonial: 'I really enjoyed this event. Thanks a lot to the organizers!',
    position: 'Sr. Manager, Data Science',
    company: 'Pfizer',
  },
];

const attendItems = [
  {
    title: 'Leaders From<br/>Across Industry',
    items: [
      'Financial Services',
      'Healthcare & Life',
      'Sciences- IT / Computer Technology',
      'AI & Data Services',
      'Government',
      'Manufacturing',
      'Retail',
      'Academia / Higher Ed',
      'Oil & Energy',
      'Telecom',
    ]
  },
  {
    title: 'Executives & Data<br />Practitioners',
    items: [
      'C-Suite',
      'Founder / Partner',
      'Innovation / R&D',
      'Data Science / Analytics',
      'IT & Cybersecurity',
      'Engineer / Architecture',
      'Sales & Marketing',
      'Operations',
      'Marketing & CS',
      'Finance',
    ]
  },
  {
    title: 'AI Startups<br />& VCs',
    items: [
      'AI Tools & Platforms',
      'Cloud Solutions',
      'Data Enrichment, Labeling & Generation',
      'Generative AI / MLLs',
      'Analytics / BI Tools',
      'Marketing & CS Solutions',
      'Computer Vision',
      'Applications',
      'RPA',
      'And More!',
    ]
  },
  {
    title: 'Partners & Service<br />Providers',
    items: [
      'Media',
      'Associations',
      'AI Training',
      'Open Source Projects',
      'Consulting',
      'Cloud Providers',
      'Data Vendors',
    ]
  },
];

function Home() {
  const logoSettings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };

  const settings = {
    dots: true,
    infinite: false,
    className: "slider variable-width",
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    variableHeight: true,
    customPaging: i => (
      <div
        className="pass-item-pagination-dot"
      >
      </div>
    )
  };

  const testimonialSettings = {
    dots: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <Arrow className="slick-arrow-style" />,
    prevArrow: <Arrow className="slick-arrow-style" />,
    customPaging: i => (
      <div
        className="pass-item-pagination-dot"
      >
      </div>
    )
  };

  return (
    <div className="home">
      <VideoBackground video={HomeVideo} />
      <HomeHero />
      <Stats />
      <div className="join-conference">
        <div className="join-conference-text">
          <h2>Join the Industry's Leading AI Conference</h2>
          <p className="body-16">Established in 2018, Ai4 is now the epicenter of the AI ecosystem and the industry’s only must-attend event. Discover the latest applications, advancements, and best practices shaping the future of AI. Enjoy dedicated content & unbeatable networking for both business & technical leaders from every major industry and job function, from leading AI startups, investors, and government organizations. Together, we’re building the future of responsible human-machine collaboration.</p>
        </div>
        <div className="join-conference-image" />
      </div>
      <div className="meet-attendees">
        <h4 className="aa_subtitle">
          Meet Our Attendees
        </h4>
        <div className="meet-attendees-logo-row">
          <Slider {...logoSettings}>
          {
            logos.map(logo => (
              <img src={logo} alt={logo} key={logo} />
            ))
          }
          </Slider>
        </div>
      </div>
      <div className="choose-pass">
        <div className="choose-pass-bg" />
        <h2>Choose your Pass</h2>
        <p className="body-16">
          Select the pass that suits your needs and gain access to the full spectrum of AI insights, networking opportunities, and transformative experiences at the Ai4 Conference.
        </p>

        <div className="choose-pass-row">
          <Slider {...settings}>
          {
            passItems.map(item => (
              <div className="pass-item">
                <h3 className="pass-item-title" dangerouslySetInnerHTML={{__html: item.title}} />
                <h1 className="pass-item-price">{ item.price !== 0 ? `$${item.price.toLocaleString()}` : 'FREE' }</h1>
                <h3 className="pass-item-discount">${item.discounted.toLocaleString()}</h3>
                <Button label={item.buttonTitle} />
                <p className={clsx('body-16', 'pass-item-description')}>
                  {item.description}
                </p>
                <ul>
                  {item.contents.map(content => (
                    <li className={clsx('body-16')} key={content}>{content}</li>
                  ))}
                </ul>
              </div>
            ))
          }
          </Slider>
        </div>
      </div>
      <div className="who-attends-desktop">
        <h2>Who Attends to AI4</h2>
        <p className={clsx('body-16')}>
          Make connections with people who can help push your AI initiatives forward.
          Our attendees are the reason Ai4 2023 is the industry’s most impactful AI event.
        </p>
        <div className="row align-items-stretch justify-content-space-between flex-wrap">
          {
            attendItems.map(item => (
              <div className="who-attends-box">
                <h2 className="who-attends-box-title" dangerouslySetInnerHTML={{__html: item.title}} />
                <ul>
                {
                  item.items.map(attendItem => (
                    <li className='body-16'>{attendItem}</li>
                  ))
                }
                </ul>
              </div>
            ))
          }
        </div>
      </div>
      <div className="who-attends">
        <div>
          <h2>Who Attends to AI4</h2>
          <p className={clsx('body-16')}>Make connections with people who can help push your AI initiatives forward. Our attendees are the reason Ai4 2023 is the industry’s most impactful AI event.</p>
          <div className="who-attends-logos-wrapper">
            <div className="who-attends-logos">
              {
                attendingLogos.map(logo => (
                  <img src={logo} alt={logo} />
                ))
              }
            </div>
          </div>
          <Button label="View all attendees" />
        </div>
        <div>
          <h2>1:1 Meetings</h2>
          <p className={clsx('body-16')}>Make connections with people who can help push your AI initiatives forward. Our attendees are the reason Ai4 2023 is the industry’s most impactful AI event.</p>
          <img src={iPhoneImg} alt="iPhone" />
        </div>
      </div>
      <VideoBackground video={RetconVideo} />
      <div className="retcon-wrapper" />
      <div className="meet-speakers">
        <div className="meet-speakers-text">
          <h2>Meet Our Speakers</h2>
          <p className="body-16">Discover the latest trends, explore recent advancements, learn best practices, and hear case studies from industry leaders and disruptors alike.</p>
          
        </div>
        <Speakers />
        <div className="speakers-button-row">
          <Button label="View all speakers" />
        </div>
      </div>
      <div className="uncover">
        <h2>Explore the Agenda</h2>
        <p className="body-16">Whether you’re a non-technical executive, new to AI, or building ML models from scratch, we’ve got you covered! Explore over 150,000 SF of talks, exhibits, networking, and special events.</p>
        <div className="agenda-row">
          <Agenda />
        </div>
        <div className="speakers-button-row">
          <Button label="View the agenda" />
        </div>
      </div>
      <div className="sponsors">
        <div className="sponsors-text">
          <div>
            <h4 className="aa_subtitle">
              introducing our
            </h4>
            <h2>2024 Sponsors</h2>
          </div>
          <p className="body-16">As a sponsor, you’ll have the exclusive opportunity to engage with the country’s largest gathering of AI industry leaders. Get in touch with your branding, networking, and thought leadership goals. See last year’s sponsors below.</p>
        </div>
        <div className="row sponsors-row">
          {
            sponsorItems.map(item => (
              <img src={item.logo} alt={item.name} />
            ))
          }
        </div>
        <div className="row button-row">
          <Button label="View all sponsors" type="secondary" />
          <Button label="Become a sponsor" />
        </div>
      </div>
      <div className="venue">
        <h4 className="aa_subtitle">venue</h4>
        <h2>The MGM Grand,<br/>Las Vegas</h2>
        <p className="body-16">
          Get the most out of your conference experience by booking in our room block, ensuring both convenience and comfort throughout your stay. Our room supply is limited, so don’t miss this opportunity to be as close as possible to the action at America’s largest hotel and casino.
        </p>
        <Button label="Register" />
      </div>
      <div className="testimonials">
        <p className="aa_subtitle">Hear What Our 3,061 Attendees Have to Say</p>
        <Slider {...testimonialSettings}>
          {
            testimonials.map(testimonial => (
              <div className="testimonial">
                <h3>”{testimonial.testimonial}”</h3>
                <p className="testimonial-position">{testimonial.position}</p>
                <p className="testimonial-company">{testimonial.company}</p>
              </div>
            ))
          }
        </Slider>
      </div>
      <ApplySection
        title="Get Ai4 in your inbox!"
        description="Sign up now to stay connected. Ensure you never miss an update about an event."
        buttonLabel="Register now"
        inputPlaceholder="Your Email"
      />
    </div>
  );
}

export default Home;
